module.exports = __webpack_public_path__ + "img/about2-mob.a8fc7c2a.webp";